/* eslint-disable import/prefer-default-export */
import DownloadAppleButton from './DownloadAppleButton.svg';
import DownloadAppleButtonFRCA from './btn_app_store_FR-CA.svg';
import DownloadAppleButtonFRFR from './btn_app_store_FR-FR.svg';
import DownloadGoogleButton from './DownloadGoogleButton.svg';
import DownloadGoogleButtonFRFR from './btn_google_play_FR-FR.svg';
import DownloadGoogleButtonFRCA from './btn_google_play_FR-CA.svg';

export {
  DownloadAppleButton,
  DownloadAppleButtonFRCA,
  DownloadAppleButtonFRFR,
  DownloadGoogleButton,
  DownloadGoogleButtonFRFR,
  DownloadGoogleButtonFRCA,
};
